// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.error-container[data-v-45eebe35]{\n    font-size: 0.75em;\n    padding-left: 0.5em;\n}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
